'use client';
import { useTranslations } from 'next-intl';
import { CatDrawer, CatHeading } from 'components/blocks-components';
import { useFilterAndSortDrawer } from '../filter-and-sort-drawer-context/filter-and-sort-drawer-context';

export const FilterAndSortDrawerWrapper = ({ children }) => {
  const t = useTranslations();
  const { drawerProps } = useFilterAndSortDrawer();

  return (
    <CatDrawer {...drawerProps} data-testid="filter-and-sort-drawer">
      <CatHeading slot="header" variant="title-sm">
        {t('FILTER_AND_SORT')}
      </CatHeading>
      {children}
    </CatDrawer>
  );
};
